import React from 'react';

const routes = [
    { path: '', title: 'Dashboard' },
    // { path: 'dashboard', title: 'Dashboard' },
    { path: 'cluster', title: 'Cluster' },

    // CMCs
    { path: 'cmcs', title: 'CMCs' },

    // Sensors
    { path: 'sensors', title: 'Sensors' },
    { path: 'add', title: 'Add' },
    { path: 'sensor_health', title: 'Sensor Health' },

    // Views
    { path: 'views', title: 'Views' },
    { path: 'alerts', title: 'Alerts' },
    { path: 'metadata', title: 'Metadata' },
    { path: 'incident_response', title: 'Incidents' },
    { path: 'packet_requests', title: 'Packet Requests' },
    { path: 'create_pcap', title: 'Create Pcap' },
    { path: 'backtesting', title: 'Backtesting' },
    { path: 'btsensor', title: 'BT Sensor' },
    { path: 'results', title: 'Results' },

    // Policies
    { path: 'policies', title: 'Policies' },

    // Policies - Sensor
    { path: 'sensor', title: 'OpenText™ NDR' },
    { path: 'geo_ip', title: 'Geo IP' },
    { path: 'exports', title: 'Exports' },
    { path: 'pcap', title: 'Packet Capture' },
    { path: 'data_tuning', title: 'Data Tuning' },
    { path: 'file_hash', title: 'File Hash' },
    { path: 'bt_conf', title: 'BT Config' },

    // Policies - Suricata
    { path: 'suricata', title: 'Suricata' },
    { path: 'rules', title: 'Rules' },
    { path: 'vars', title: 'Vars' },
    { path: 'bt_rules', title: 'BT Rules' },

    // Policies - Zeek
    { path: 'zeek', title: 'Zeek' },
    { path: 'scripts', title: 'Scripts' },
    { path: 'bt_scripts', title: 'BT Scripts' },
    { path: 'editor', title: 'Editor' },
    { path: 'settings', title: 'Settings' },
    { path: 'zeek_indicators', title: 'Threat Intelligence' },

    // System
    { path: 'users_roles', title: 'Users & Roles' },
    { path: 'create_user', title: 'Create User' },
    { path: 'update_user', title: 'Update User' },
    { path: 'create_role', title: 'Create Role' },
    { path: 'update_role', title: 'Update Role' },
    { path: 'password', title: 'Set Password' },
    { path: 'system', title: 'System' },
    { path: 'assets', title: 'Assets' },
    { path: 'audit', title: 'Audit' },
    { path: 'audit_reports', title: 'Audit Reports' },
    { path: 'cmc_health', title: 'CMC Health' },
    { path: 'mc2_health', title: 'MC2 Health' },
    { path: 'upgrades_mc2', title: 'MC2 Upgrades' },
    { path: 'license', title: 'License' },
    { path: 'reports', title: 'Reports' },
    { path: 'update', title: 'Update' },

    // System - Configuration
    { path: 'configuration', title: 'Configuration' },
    { path: 'auth', title: 'Authentication' },
    { path: 'ldap', title: 'LDAP' },
    { path: 'priv', title: 'Privilege' },
    { path: 'standard', title: 'Standard' },
    { path: 'access_keys', title: 'Access Keys' },
    { path: 'create_access_key', title: 'Create Access Key' },
    { path: 'audit', title: 'Audit' },
    { path: 'elastic', title: 'Elastic' },
    { path: 'event', title: 'Event' },
    { path: 'exports', title: 'Exports' },
    { path: 'health', title: 'Health' },
    { path: 'email', title: 'Email' },
    { path: 'proxy', title: 'Proxy' },
    { path: 'reports', title: 'Reports' },
    { path: 'snmp', title: 'SNMP' },
    { path: 'ui', title: 'UI' },
    { path: 'vpn', title: 'VPN' },

    //System Mirroring
    { path: 'port_mirroring', title: 'Network Traffic Mirroring' },
    { path: 'aws', title: 'AWS' },
    { path: 'gcp', title: 'Google Cloud' },
    { path: 'create_group', title: 'Create Auto Scaling Group' },
    { path: 'update_group', title: 'Update Auto Scaling Group' },
    { path: 'create_filter', title: 'Create Traffic Mirror Filter' },
    { path: 'update_filter', title: 'Update Traffic Mirror Filter' },
    { path: 'create_target', title: 'Create Traffic Mirror Target' },
    { path: 'create_session', title: 'Create Traffic Mirror Session' },
    { path: 'update_session', title: 'Update Traffic Mirror Session' },
    { path: 'configure_filter_rule', title: 'ConfigureTraffic Mirror Filter Rules' },
    { path: 'aws_credentials', title: 'AWS Credentials' },
    { path: 'gcp_credentials', title: 'Configure Account Key' },
    { path: 'create_tunnel_proxy', title: 'Create Tunnel Proxy' },
    { path: 'create_instance_group', title: 'Create Instance Group' },
    { path: 'update_instance_group', title: 'Update Instance Group' },
    { path: 'create_load_balancer', title: 'Create Load Balancer' },
    { path: 'update_load_balancer', title: 'Update Load Balancer' },
    { path: 'create_packet_mirror', title: 'Create Packet Mirror' },
    { path: 'update_packet_mirror', title: 'Update Packet Mirror' },

    // Anomalies
    { path: 'anomalies', title: 'Anomalies' },
    { path: 'anomaly_detection', title: 'Anomaly Detection' },
    { path: 'opensearch', title: 'OpenSearch Rules' },

    // System Upgrades
    { path: 'upgrades', title: 'Upgrades' },
    { path: 'cmc', title: 'CMC' },
    { path: 'datanode', title: 'Datanode' },
    { path: 'sensor', title: 'Sensor' },
    { path: 'create', title: 'Create' },
    { path: 'edit', title: 'Edit' },

    // Support
    { path: 'support', title: 'Support' },
    { path: 'filehash', title: 'File Hash' },
    { path: 'filter_reference', title: 'Filter Reference' },
    { path: 'api_docs', title: 'API Documentation' },
];

// I'd rather do this with an event tied to the router but that doesn't seem to be an option at the moment with v6
const EmptyRoutes = [
    /^\/cmcs\/health$/,
    /^\/cmcs\/edit$/,
    /^\/cmcs\/sensor_health$/,
    /^\/cmcs\/sensor_health\/\w[a-zA-Z0-9_.\(\)\{\}\[\]\-]{0,31}$/,
    /^\/sensors\/health$/,
    /^\/sensors\/edit$/,
    /^\/policies\/suricata\/rules\/editor$/,
    /^\/policies\/suricata\/rules\/editor\/\w[a-zA-Z0-9_.\(\)\{\}\[\]\-]{0,31}$/,
    /^\/system\/users_roles\/password$/,
    /^\/system\/users_roles\/update_user$/,
    /^\/system\/users_roles\/update_role$/,
    /^\/system\/port_mirroring\/aws\/update_group$/,
    /^\/system\/port_mirroring\/aws\/update_filter$/,
    /^\/system\/port_mirroring\/aws\/configure_filter_rule$/,
    /^\/system\/port_mirroring\/aws\/update_session$/,
    /^\/system\/port_mirroring\/gcp\/update_instance_group$/,
    /^\/system\/port_mirroring\/gcp\/update_load_balancer$/,
    /^\/system\/port_mirroring\/gcp\/update_packet_mirror$/,
];

export {
    routes as default,
    EmptyRoutes,
};
